/**
 * 描述：angularjs扩展
 * 作者：bai.zhiming
 * 日期：2017-6-16
 */
angular.module("angularPlusModule", ["trsNgIfModule"])
    .config(['$qProvider', '$validationProvider', function($qProvider, $validationProvider) {
        $validationProvider.setSuccessHTML(function(msg) {
            return "";
        });
        $qProvider.errorOnUnhandledRejections(false); //解决注入报错bug
        /**
         *ProcessingData [ description] 处理返回数据中的特殊字符
         * @return {[type]} [description]
         */
        angular.ProcessingData = function(data) {
            function formateData(data){
	            for(var prop in data){
	            	if(typeof(data[prop]) == "object" && Object.prototype.toString.call(data[prop]).toLowerCase() == "[object object]" && !data[prop].length ){
				        formateData(data[prop]);
				    }else if(Array.isArray(data[prop])){
						var arr = data[prop];
						for(var index in arr){  
				            formateData(arr[index]);  
				        } 
					}else if(typeof(data[prop])==='string'){
						data[prop] = data[prop].replace(/&amp;amp;/g, "&")
										.replace(/&amp;/g, "&")
										.replace(/&lt;/g, "<")
										.replace(/&gt;/g, ">")
										.replace(/&quot;/g, "\"")
										.replace(/&times;/g, "×")
										.replace(/&divide;/g, "÷")
										.replace(/&copy;/g, "©")
										.replace(/&reg;/g, "®");
					}
				}
	            return data;
            }
            var newData;
            try{
            	newData = formateData(data)
            }catch(e){
            	newData = data;
            }finally{
            	 return newData;
            }
        };
        /**
         * [assembleTree description]组装树
         * @param  {[array]} array [description] 节点数组
         * @param  {[string]} childrenName [varname] [description] 子节点属性名称
         * @return {[type]}      [description] null
         */
        angular.assembleTree = function(array, childrenName, sortName, sortWay, pnodeKey, nodeKey) {
            var array1 = angular.copy(array);
            var array2 = angular.copy(array);
            pnodeKey = !!pnodeKey ? pnodeKey : "pnodeid";
            nodeKey = !!nodeKey ? nodeKey : "nodeid";
            var i = array1.length - 1;
            while (i >= 0) {
                var j = array2.length - 1;
                var flag = false;
                while (j >= 0) {
                    if (array1[i][pnodeKey] === array2[j][nodeKey]) {
                        angular.isDefined(array1[j][childrenName]) ? (array1[j][childrenName].push(array1[i])) : (array1[j][childrenName] = [array1[i]]);
                        angular.isDefined(array2[j][childrenName]) ? (array2[j][childrenName].push(array1[i])) : (array2[j][childrenName] = [array1[i]]);
                        flag = true;
                    } else if (angular.isDefined(array2[j][childrenName])) {
                        flag = checkChildren(array1[i], array2[j][childrenName], childrenName, flag);
                    }
                    if (flag) {
                        splitElement(array1[i], array2);
                    }
                    j--;
                }
                i--;
            }

            function checkChildren(node, childrenlist, childrenName, flag) {
                var i = childrenlist.length - 1;
                while (i >= 0) {
                    if (node[pnodeKey] === childrenlist[i][nodeKey]) {
                        angular.isDefined(childrenlist[i][childrenName]) ? (childrenlist[i][childrenName].push(node)) : (childrenlist[i][childrenName] = [node]);
                        flag = true;
                        break;
                    } else if (angular.isDefined(childrenlist[i][childrenName])) {
                        flag = checkChildren(node, childrenlist[i][childrenName], childrenName, flag);
                        if (flag === true) break;
                    }
                    i--;
                }
                return flag;
            }

            function splitElement(node, list) {
                for (var i = 0; i < list.length; i++) {
                    if (node[nodeKey] === list[i][nodeKey]) {
                        list.splice(i, 1);
                        break;
                    }
                }
            }

            function sortChildren(children, childrenName, sortName) {
                children.sort(function(a, b) {
                    return sortWayFn(a, b, sortName);
                });
                for (var i = 0; i < children.length; i++) {
                    var child = children[i];
                    if (angular.isDefined(child[childrenName])) {
                        sortChildren(child[childrenName], childrenName, sortName);
                    }
                }
            }

            function sortWayFn(a, b) {
                if (sortWay === "asc") {
                    return a[sortName] - b[sortName];
                } else {
                    return b[sortName] - a[sortName];
                }
            }
            if (sortName) {
                array2.sort(function(a, b) {
                    return sortWayFn(a, b);
                });
                for (var i = 0; i < array2.length; i++) {
                    sortChildren(array2[i][childrenName], childrenName);
                }
            }
            return array2;
        };
        /**
         * [expandTree description]展开树
         * @param  {[]} [description]
         * @param  {[]} [description] 
         * @return {[type]}      [description] null
         */
        angular.expandTree = function(treeData, expandedNodes, childrenName) {
            for (var i = 0; i < treeData.length; i++) {
                expandedNodes.push(treeData[i]);
                if (angular.isDefined(treeData[i][childrenName]) && treeData[i][childrenName].length > 0) {
                    expandChildren(treeData[i][childrenName], expandedNodes, childrenName);
                }
            }

            function expandChildren(childrenList, expandedNodes, childrenName) {
                for (var j = 0; j < childrenList.length; j++) {
                    expandedNodes.push(childrenList[j]);
                    if (angular.isDefined(childrenList[j][childrenName] && childrenList[j][childrenName].length > 0)) {
                        expandChildren(childrenList[j][childrenName], expandedNodes, childrenName);
                    }
                }
            }
        };
        /**
         * [packageIds description]将数组中指定元素的值以指定分隔符拼接成串
         * @param  {[array]} array [description] 需要处理的数组
         * @param  {[string]} separator [description] 分割符
         * @param  {[string]} attributename [description] 属性名称
         * @return {[string]} ids  [description] 处理完成的串
         */
        angular.packageIds = function(array, separator, attributename) {
            var idsArray = [];
            for (var i = 0; i < array.length; i++) {
                idsArray.push(array[i][attributename]);
            }
            return idsArray.join(separator);
        };
        /**
         * [globalConfig description] 全局配置
         * @type {Object}
         */
        angular.globalConfig = {
            pictureServer: ""
        };
        /**
         * [invalidPosition description] 错误表单项定位方法
         * @return {[type]} [description]
         */
        angular.invalidPosition = function(form, $element) {
            var index = 0;
            for (var j in form.$error) {
                var item = $element.find("[name='" + j + "']")[0];
                var itemScope = $(item).prev().data().$scope;
                if ($(item).attr("is-show-tips")) {
                    itemScope.isShowTips = true;
                }
                if (index === 0) {
                    item.focus();
                    item.blur();
                    index++;
                }
            }
        };
    }]).filter("myDateFilter", ["$log", function($log) {
        return function(input) {
            var date = new Date(Date.parse(input));
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            var day = date.getDate();
            day = day < 10 ? "0" + day : day;
            return year + "-" + month + "-" + day;
        };
    }]);